import "core-js/modules/es.array.map.js";
import React from 'react';
import { Loading } from '../../../Loading';
import { SonIAContainer, Image, ResponsiveImage, CommonContainer, TextContainer, TitleContainer, Title, Description, ButtonsContainer, Button, SelectedButton } from './partials';
export var SonIA = function SonIA(_ref) {
  var showActions = _ref.showActions,
    icon = _ref.icon,
    title = _ref.title,
    content = _ref.content,
    options = _ref.options,
    selectedOption = _ref.selectedOption,
    loading = _ref.loading,
    _onClick = _ref.onClick;
  return React.createElement(SonIAContainer, {
    id: "sonia-container"
  }, React.createElement(Image, {
    src: icon,
    alt: title
  }), React.createElement(CommonContainer, null, React.createElement(TextContainer, null, React.createElement(TitleContainer, null, React.createElement(ResponsiveImage, {
    src: icon,
    alt: title
  }), React.createElement(Title, null, title)), React.createElement(Description, null, loading ? React.createElement(React.Fragment, null, React.createElement("p", null, "Ten paciencia, hasta la IA necesita tiempo para analizar estos datos. No tardar\xE9 m\xE1s de 30 segundos."), React.createElement("div", null, React.createElement(Loading, {
    height: 100
  }))) : content)), !loading && showActions ? React.createElement(ButtonsContainer, null, options.map(function (option) {
    var ButtonComponent = Button;
    if (option.key === selectedOption) ButtonComponent = SelectedButton;
    return React.createElement(ButtonComponent, {
      key: "sonia-button-".concat(option.key),
      onClick: function onClick() {
        return _onClick(option.key);
      }
    }, option.label);
  })) : null));
};